import { TasklistService } from '@/api/tasklist'
import TableRequest from '@/components/request/TableRequest'
import { Outlet, useSearchParams } from 'react-router-dom'
import { UserService } from '@/api/user'

export default function RequestCompleted() {
  const [searchParams] = useSearchParams()
  const processKey = searchParams.get('processKey')
  const page = searchParams.get('page') ?? '0'
  const { data: profile } = UserService.useGetProfile()

  const { data: completedRequests, isLoading } = TasklistService.useGetCompletedMyRequest({
    username: profile?.username ?? '',
    processKey: processKey ?? '',
    page: page,
  })

  return (
    <section className="bg-white rounded">
      <TableRequest
        type="completed"
        title="Completed Requests"
        page={page}
        processKey={processKey ?? ''}
        isLoading={isLoading}
        data={completedRequests ?? []}
      />
      <Outlet />
    </section>
  )
}
